var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('i',{staticClass:"el-icon-loading"}),_vm._t("default",function(){return [_c('p',[_vm._v("加载中...")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }